<template>
    <v-dialog :value="value" persistent max-width="450px">
        <v-card>
            <v-card-title>
                {{ $t('assign_contact') }}
            </v-card-title>
            <v-card-text>
                <div class="mb-5">
                    <LabelField :label="$t('search')">
                        <v-autocomplete
                            v-model="assignedAddress"
                            :loading="loading"
                            :items="foundAddresses.models"
                            item-text="displayTitle"
                            item-value="id"
                            return-object
                            :search-input.sync="query"
                            no-filter
                            dense
                            outlined
                            append-icon="ic ic-16 ic-searchmagnifier"
                            hide-no-data
                            hide-details
                            :placeholder="$t('search_contact')"
                        >
                            <template #item="data">
                                <AddressComboListItem :item="data.item" />
                            </template>
                        </v-autocomplete>
                    </LabelField>
                </div>
                <div :class="{ 'mb-5': !userIsStaff() }">
                    <v-textarea
                        v-model="functionText"
                        dense
                        outlined
                        rows="3"
                        placeholder="Funktion / Verknüpfungsinformation, z.B. 'Veranstaltungsleiterin'"
                    ></v-textarea>
                </div>
                <div class="mb-5">
                    <v-checkbox
                        class="mt-0 pt-0"
                        :input-value="publishFrontend"
                        :label="$t('frontend_publish_contact')"
                        hide-details="auto"
                        @change="publishFrontend = $event"
                    >
                        <template #label>
                            <KpIcon left icon-cls="published" color="grey" />
                            <span v-html="$t('frontend_publish_contact')"></span>
                        </template>
                    </v-checkbox>
                </div>
                <div v-if="userIsStaff()" class="mb-5 d-flex">
                    <v-checkbox
                        class="mt-0 pt-0"
                        :input-value="isMainContact"
                        :label="$t('main_contact_msgs')"
                        hide-details="auto"
                        @change="isMainContact = $event"
                    >
                        <template #label>
                            <KpIcon left icon-cls="star" color="grey" />
                            <span v-html="$t('main_contact_msgs')"></span>
                        </template>
                    </v-checkbox>
                    <KpTooltip>
                        <template #activator="{ on, attrs }">
                            <i v-bind="attrs" class="ic ic-16 ic-col-light-blue ic-support ml-1" v-on="on"></i>
                        </template>
                        <div style="max-width: 350px">asfdsfsdfdfs</div>
                    </KpTooltip>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <PlainBtn @click="$emit('input', false)">{{ $t('schliessen') }}</PlainBtn>
                <ActionBtn
                    :disabled="!assignedAddress"
                    @click="
                        $emit('select-address', {
                            address: assignedAddress,
                            functionText,
                            isMainContact,
                            publishFrontend,
                        })
                    "
                >
                    <KpIcon icon-cls="pencil" color="white" />
                    <span>{{ $t('assign_contact') }}</span>
                </ActionBtn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { AddressCollection } from '@/models/Address';
import { debounce } from '@/helpers/tools';
import { defineComponent } from 'vue';
import AddressComboListItem from './AddressComboListItem.vue';
import { userIsStaff } from '@/helpers/auth';

export default defineComponent({
    name: 'LinkExistingContact',
    components: { AddressComboListItem },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const collection = new AddressCollection();
        // Only allow blank addresses, no locations or event organizers:
        collection.setFilter('type', 'address');
        return {
            assignedAddress: null,
            loading: false,
            foundAddresses: collection,
            query: '',
            functionText: '',
            isMainContact: false,
            publishFrontend: false,
        };
    },
    watch: {
        value(newVal, oldVal) {
            // on show, clear selection:
            if (newVal && !oldVal) {
                this.assignedAddress = null;
                this.foundAddresses.clear();
            }
        },
        query(newVal, oldVal) {
            newVal && newVal !== oldVal && newVal.length >= 3 && this.searchAddresses(newVal);
        },
    },
    methods: {
        userIsStaff,

        searchAddresses: debounce(async function (this: any, query) {
            this.loading = true;
            await this.foundAddresses.query({ query });
            this.loading = false;
        }, 250),
    },
});
</script>
